/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Goal_Eyes_TInputs */

const en_funnel_ob_goal_eyes_t = /** @type {(inputs: Funnel_Ob_Goal_Eyes_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rest my eyes`)
};

const es_funnel_ob_goal_eyes_t = /** @type {(inputs: Funnel_Ob_Goal_Eyes_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descansar la vista`)
};

/**
* | output |
* | --- |
* | "Rest my eyes" |
*
* @param {Funnel_Ob_Goal_Eyes_TInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_goal_eyes_t = /** @type {((inputs?: Funnel_Ob_Goal_Eyes_TInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Goal_Eyes_TInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_goal_eyes_t(inputs)
	return en_funnel_ob_goal_eyes_t(inputs)
});